import styled from 'styled-components'
import { lightGray } from '../../styles/variables'
import { fieldLabel } from '../../styles/common'

const TagsContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${fieldLabel}

  &.disabled {
    opacity: 0.7;
  }
`

const Tags = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`

const TagContainer = styled.div`
  margin-right: 16px;
  position: relative;
  margin-bottom: 8px;
`

const Tag = styled.div`
  box-sizing: border-box;
  text-align: center;
  padding: 10px 40px;
  outline: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }

  background: none;
  border: 2px solid ${lightGray};
  color: ${lightGray};

  ${({ selected }) => selected ? `
    background: ${lightGray};
    border: 2px solid ${lightGray};
    color: white;
  ` : ''}

`

export default {
  TagsContainer,
  TagContainer,
  Tags,
  Tag,
}
